// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609280535/js/" + chunkId + "." + {"44":"cd760b6c","225":"7131bcb8","481":"80ef8f68","486":"a5f81a3d","770":"815396b0"}[chunkId] + ".0.9672366066785039.chunk.js";
};